// Настройка горизонтального скролла для multicolumn-list
document.querySelector(
  '#shopify-section-template--26116469850244__16385421449772a715 .multicolumn-list'
).style.cssText += `
  position: relative;
  flex-wrap: inherit;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scroll-padding-left: 1rem;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
`;

// Получение всех карточек и заголовков
let cardList = document.querySelectorAll(
  '#shopify-section-template--26116469850244__16385421449772a715 .multicolumn-card'
);
let multicolumnCardInfo = document.querySelectorAll(
  '#shopify-section-template--26116469850244__16385421449772a715 .multicolumn-card .multicolumn-card__info h3'
);
let cardElementList = document.querySelectorAll(
  '#shopify-section-template--26116469850244__16385421449772a715 .multicolumn-list__item'
);
let slider = document.querySelector(
  '#shopify-section-template--26116469850244__16385421449772a715 .slider-buttons'
);

// Вставка iframe с нужным размером и настройками
cardList.forEach(function (el, i) {
  el.innerHTML = `
    <iframe
      width=100%
      height="257"
      src="https://www.youtube.com/embed/${multicolumnCardInfo[i].innerText}"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      style="border-radius: 8px;"
    ></iframe>
  `;
});

// Установка отступов между карточками
cardElementList.forEach(function (el) {
  el.style.cssText += `
    margin-top: 0 !important;
    margin-right: 8px;
    flex: 0 0 auto;
  `;
});

// Отображение кнопок слайдера
slider.style.cssText += 'display: flex !important;';


